import { fmtDateTime } from "@/lib/format";

const LABEL = {
  create: "SO dibuat", update: "SO diedit", process: "Diproses", delivery: "Pengiriman", void: "Void",
  process_failed: "Proses gagal (Odoo)", delivery_failed: "Kirim gagal (Odoo)",
  void_request: "Permintaan void", void_return: "Retur stok", void_rejected: "Void ditolak", delete: "Dihapus",
  credit_hold: "Tertahan batas kredit", credit_approve: "Kredit disetujui", credit_reject: "Kredit ditolak",
  credit_clear: "Kembali dalam batas kredit", price_override: "Harga manual", close: "Order ditutup",
};

export function AuditTimeline({ items }) {
  if (!items.length) return <p>Belum ada riwayat.</p>;
  return items.map((a) => (
    <div className={`audit-item ${a.action === "update" ? "edited" : ""}`} key={a.id} data-testid={`audit-${a.action}-${a.id}`}>
      <i />
      <strong>{LABEL[a.action] || a.action}{a.field ? ` · ${a.field}` : ""}</strong>
      <span>{a.note || a.new_value || ""}</span>
      {a.changes?.length > 0 && (
        <ul className="audit-changes" data-testid={`audit-changes-${a.id}`}>
          {a.changes.map((c, i) => (
            <li key={i}><b>{c.field}</b>{c.old ? <><s>{c.old}</s> → </> : " "}<em>{c.new ?? "dihapus"}</em></li>
          ))}
        </ul>
      )}
      <small>{a.actor_name ? `${a.actor_name} · ` : ""}{a.actor_email} · {fmtDateTime(a.created_at)}</small>
    </div>
  ));
}
